import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AppShell } from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import SearchPage from "@/pages/SearchPage";
import Lists from "@/pages/Lists";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AppShell>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/lists" element={<Lists />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </AppShell>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
